module.exports = __webpack_public_path__ + "static/7-42783787f38305c6f99eaa4302cf9c41.jpg";